import AvitoPage from "./Avito"
import BwhitePage from "./Bwhite"
import KuperPage from "./Kuper"
import MarketsUpdateStatusPage from "./MarketsUpdateStatus"
import MegaMarketPage from "./Megamarket"
import OzonPage from "./Ozon"
import WbPage from "./Wb"
import YandexPage from "./Yandex"


const MarketPages = {
    Ozon: OzonPage,
    Yandex: YandexPage,
    Wb: WbPage,
    MegaMarket: MegaMarketPage,
    Kuper: KuperPage,
    Bwhite: BwhitePage,
    Avito: AvitoPage,

    MarketsUpdateStatus: MarketsUpdateStatusPage,
}

export default MarketPages